// extracted by mini-css-extract-plugin
module.exports = {"collectionContainer":"collection_collectionContainer__1RvyA","cardGrid":"collection_cardGrid__IqSNK"};